module.exports = __webpack_public_path__ + "img/xc_icon.97b3d599.png";